<template>
  <b-modal
    ref="modal"
    :title="$t('component.unsavedChangesModal.title')"
    centered
    static
    size="sm"
    modal-class="save-modal"
    @shown="onShown"
  >
    <b-row class="px-3">
      <b-col class="text-center d-flex flex-column">
        <i
          class="fal fa-money-check-edit main py-2 fa-2x"
          aria-hidden="true"
        />
        <span class="mt-2">{{ textToShow }}</span>
        <span>
          <strong>{{ $t('component.unsavedChangesModal.question') }}</strong>
        </span>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <b-col>
          <b-button
            v-shortkey="['esc']"
            class="btn-shadow"
            block
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @shortkey.prevent="_cancel"
            @click="_cancel"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </b-col>
        <b-col>
          <vt-loading-button
            class="btn--primary btn-sm btn-block btn-shadow"
            :params="{ promise: _dontSaveAndContinue, shortkeys: ['alt', 'n'] }"
          >
            {{ $t('component.unsavedChangesModal.dontSave') }}
          </vt-loading-button>
        </b-col>
        <b-col>
          <vt-loading-button
            ref="saveButton"
            class="btn--primary btn-sm btn-block btn-shadow"
            :params="{ promise: _saveAndContinue, shortkeys: ['alt', 's'] }"
          >
            {{ $t('global.save') }}
          </vt-loading-button>
        </b-col>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
    name: 'UnsavedChangesModal',
    data() {
        return {
            saveCallback: null,
            continueCallback: null,
            cancelCallback: null,
            customTextToShow: null
        }
    },
    computed: {
        textToShow() {
            return this.customTextToShow ?? this.$tc('component.unsavedChangesModal.text')
        }
    },
    methods: {
        onShown() {
            this.$refs.saveButton.focus()
        },
        _show() {
            this.$refs.modal?.show()
        },
        _hide() {
            this.$refs.modal?.hide()
        },
        askAndExecuteCallbacks(saveCallback, continueCallback, cancelCallback, customTextToShow) {
            this.saveCallback = saveCallback
            this.continueCallback = continueCallback
            this.cancelCallback = cancelCallback
            this.customTextToShow = customTextToShow
            this._show()
        },
        async _saveAndContinue() {
            const saveSuccessful = await this.saveCallback()
            if (saveSuccessful) {
                await this.continueCallback()
            }
            this._hide()
        },
        async _cancel() {
            if (this.cancelCallback) {
                this.cancelCallback()
            }
            this._hide()
        },
        async _dontSaveAndContinue() {
            await this.continueCallback()
            this._hide()
        }
    }
}
</script>

<style lang="scss">
.save-modal .modal-dialog {
    @include mq(desktop-wide, max) {
        width: 35%;
    }
    @include mq(tablet-wide, max) {
        width: 50%;
    }
}
</style>

<style lang="scss" scoped>
</style>
